<div class="container-fluid">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Completar Cadastro</h4>
        </div>
        <div class="card-body">
          <form [formGroup]="clienteForm" (ngSubmit)="onSubmit()">
            <!-- Informações Básicas da Empresa -->
            <legend class="mt-4">IDENTIFICAÇÃO DA INSTITUIÇÃO</legend>
            <div class="row">
              <div class="col-md-5">
                <div class="form-group">
                  <label for="nomeFantasia">Nome Fantasia</label>
                  <input type="text" class="form-control" id="nomeFantasia" formControlName="nomeFantasia"
                    [readonly]="!isEditing">
                </div>
              </div>
              <div class="col-md-5">
                <div class="form-group">
                  <label for="razaoSocial">Razão Social</label>
                  <input type="text" class="form-control" id="razaoSocial" formControlName="razaoSocial"
                    [readonly]="!isEditing">
                </div>
              </div>

              <div class="col-md-2">
                <div class="form-group">
                  <div class="custom-control custom-switch mt-4">
                    <input type="checkbox" class="custom-control-input" id="isEmpresaGestora"
                      formControlName="isEmpresaGestora" [disabled]="!isEditing">
                    <label class="custom-control-label" for="isEmpresaGestora">Empresa Gestora</label>
                  </div>
                </div>
              </div>

            </div>

            <div class="row">
              <div class="col-md-4">
                <div class="form-group">
                  <label for="cnpj">CNPJ</label>
                  <input type="text" class="form-control" id="cnpj" formControlName="cnpj" [readonly]="!isEditing">
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label for="dataFundacao">Data de Fundação</label>
                  <input type="datetime-local" class="form-control" id="dataFundacao" formControlName="dataFundacao"
                    [readonly]="!isEditing">
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label for="cnes">CNES</label>
                  <input type="text" class="form-control" id="cnes" formControlName="cnes" [readonly]="!isEditing">
                </div>
              </div>
            </div>

            <!-- Identificação do Profissional -->
            <legend class="mt-4">IDENTIFICAÇÃO DO PROFISSIONAL (Preencher apenas nos casos em que o proponente for Pessoa Física)</legend>
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label for="pessoaNome">Nome</label>
                  <input type="text" class="form-control" id="pessoaNome" formControlName="pessoaNome"
                    [readonly]="!isEditing">
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label for="pessoaEmail">Email</label>
                  <input type="email" class="form-control" id="pessoaEmail" formControlName="pessoaEmail"
                    [readonly]="!isEditing">
                </div>
              </div>
              
            </div>

            <div class="row">
              <div class="col-md-4">
                <div class="form-group">
                  <label for="pessoaCpf">CPF</label>
                  <input type="text" class="form-control" id="pessoaCpf" formControlName="pessoaCpf"
                    [readonly]="!isEditing">
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label for="pessoaDataNascimento">Data de Nascimento</label>
                  <input type="datetime-local" class="form-control" id="pessoaDataNascimento" formControlName="pessoaDataNascimento"
                    [readonly]="!isEditing">
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label for="pessoaTelefone">Telefone</label>
                  <input type="text" class="form-control" id="pessoaTelefone" formControlName="pessoaTelefone"
                    [readonly]="!isEditing">
                </div>
              </div>
            </div>


            <!-- Endereço -->
            <legend class="mt-4">LOCALIZAÇÃO</legend>
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label for="endereco">Endereço</label>
                  <input type="text" class="form-control" id="endereco" formControlName="endereco"
                    [readonly]="!isEditing">
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-4">
                <div class="form-group">
                  <label for="numero">Número</label>
                  <input type="text" class="form-control" id="numero" formControlName="numero" [readonly]="!isEditing">
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label for="bairro">Bairro</label>
                  <input type="text" class="form-control" id="bairro" formControlName="bairro" [readonly]="!isEditing">
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label for="cidade">Cidade</label>
                  <select class="form-control" id="cidade" formControlName="idCidade" [disabled]="!isEditing">
                    <option value="">Selecione uma cidade</option>
                    <option *ngFor="let cidade of cidades" [value]="cidade.id">
                      {{ cidade.nome }}
                    </option>
                  </select>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-4">
                <div class="form-group">
                  <label for="telefonePrincipal">Telefone Principal</label>
                  <input type="text" class="form-control" id="telefonePrincipal" formControlName="telefonePrincipal"
                    [readonly]="!isEditing">
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label for="telefoneAuxiliar">Telefone Auxiliar</label>
                  <input type="text" class="form-control" id="telefoneAuxiliar" formControlName="telefoneAuxiliar"
                    [readonly]="!isEditing">
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label for="telefoneWhatsapp">WhatsApp</label>
                  <input type="text" class="form-control" id="telefoneWhatsapp" formControlName="telefoneWhatsapp"
                    [readonly]="!isEditing">
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label for="site">Site</label>
                  <input type="text" class="form-control" id="site" formControlName="site" [readonly]="!isEditing">
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label for="email">Email</label>
                  <input type="email" class="form-control" id="email" formControlName="email" [readonly]="!isEditing">
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label for="funcionamento">Horário de Funcionamento</label>
                  <input type="text" class="form-control" id="funcionamento" formControlName="funcionamento"
                    [readonly]="!isEditing">
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group">
                  <label for="secretariaAtendente">Secretaria/Atendente</label>
                  <input type="text" class="form-control" id="secretariaAtendente" formControlName="secretariaAtendente"
                    [readonly]="!isEditing">
                </div>
              </div>
            </div>

            <!-- Informações do Responsável -->
            <legend class="mt-4">RESPONSÁVEL TÉCNICO DA INSTITUIÇÃO</legend>
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label for="responsavelNome">Nome do Responsável</label>
                  <input type="text" class="form-control" id="responsavelNome" formControlName="responsavelNome"
                    [readonly]="!isEditing">
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label for="responsavelConselho">Conselho</label>
                  <input type="text" class="form-control" id="responsavelConselho" formControlName="responsavelConselho"
                    [readonly]="!isEditing">
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label for="responsavelRegistro">Registro</label>
                  <input type="text" class="form-control" id="responsavelRegistro" formControlName="responsavelRegistro"
                    [readonly]="!isEditing">
                </div>
              </div>

            </div>

            <!-- Informações Administrativas -->
            <legend class="mt-4">ADMINISTRADOR DA INSTITUIÇÃO</legend>
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label for="admNome">Nome do Administrador</label>
                  <input type="text" class="form-control" id="admNome" formControlName="admNome"
                    [readonly]="!isEditing">
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label for="admFuncao">Função</label>
                  <input type="text" class="form-control" id="admFuncao" formControlName="admFuncao"
                    [readonly]="!isEditing">
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label for="admCelular">Celular</label>
                  <input type="text" class="form-control" id="admCelular" formControlName="admCelular"
                    [readonly]="!isEditing">
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label for="admEmail">Email</label>
                  <input type="email" class="form-control" id="admEmail" formControlName="admEmail"
                    [readonly]="!isEditing">
                </div>
              </div>
            </div>

            <!-- Informações Adicionais -->
            <legend class="mt-4">Informações Adicionais</legend>
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label for="servicosOfertados">Serviços Ofertados</label>
                  <textarea class="form-control" id="servicosOfertados" formControlName="servicosOfertados" rows="3"
                    [readonly]="!isEditing"></textarea>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label for="observacao">Observações</label>
                  <textarea class="form-control" id="observacao" formControlName="observacao" rows="3"
                    [readonly]="!isEditing"></textarea>
                </div>
              </div>
            </div>

            <div class="row mt-3">
              <div class="col-12">
                <button type="button" class="btn btn-warning mr-2" (click)="toggleEdit()">
                  {{ isEditing ? 'Cancelar Edição' : 'Editar' }}
                </button>
                <button type="submit" class="btn btn-success" [disabled]="!isEditing || !clienteForm.valid">
                  Salvar
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>

  <!-- Tabela de Clientes -->
  <div class="row mt-4">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Clientes Cadastrados</h4>
        </div>
        <div class="card-body">
          <table datatable [dtOptions]="dtOptions" class="table table-striped table-bordered">
            <thead>
              <tr>
                <th>ID</th>
                <th>Nome Fantasia</th>
                <th>CNPJ</th>
                <th>Data Cadastro</th>
                <th>Empresa Gestora</th>
                <th>Status</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let cliente of clientes">
                <td>{{ cliente.id }}</td>
                <td>{{ cliente.nomeFantasia }}</td>
                <td>{{ cliente.cnpj }}</td>
                <td>{{ cliente.dataCadastro | date:'dd/MM/yyyy HH:mm' }}</td>
                <td>
                  <span [class]="cliente.isEmpresaGestora ? 'badge badge-success' : 'badge badge-secondary'">
                    {{ cliente.isEmpresaGestora ? 'Sim' : 'Não' }}
                  </span>
                </td>
                <td>
                  <span [class]="cliente.status === 'Ativo' ? 'badge badge-success' : 'badge badge-danger'">
                    {{ cliente.status }}
                  </span>
                </td>
                <td>
                  <button class="btn btn-sm btn-primary mr-1" (click)="editarCliente(cliente)">
                    <i class="feather icon-edit"></i>
                  </button>
                  <button class="btn btn-sm" [class]="cliente.status === 'Ativo' ? 'btn-warning' : 'btn-success'"
                    (click)="alterarStatus(cliente)">
                    <i class="feather" [class]="cliente.status === 'Ativo' ? 'icon-user-x' : 'icon-user-check'"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div> 